/* automatically generated by JSCoverage - do not edit */
try {
  if (typeof top === 'object' && top !== null && typeof top.opener === 'object' && top.opener !== null) {
    // this is a browser window that was opened from another window

    if (!top.opener._$jscoverage) {
      top.opener._$jscoverage = {};
    }
  }
} catch (e) {}
try {
  if (typeof top === 'object' && top !== null) {
    // this is a browser window

    try {
      if (typeof top.opener === 'object' && top.opener !== null && top.opener._$jscoverage) {
        top._$jscoverage = top.opener._$jscoverage;
      }
    } catch (e) {}
    if (!top._$jscoverage) {
      top._$jscoverage = {};
    }
  }
} catch (e) {}
try {
  if (typeof top === 'object' && top !== null && top._$jscoverage) {
    _$jscoverage = top._$jscoverage;
  }
} catch (e) {}
if (typeof _$jscoverage !== 'object') {
  _$jscoverage = {};
}
if (!_$jscoverage['mediator.js']) {
  _$jscoverage['mediator.js'] = [];
  _$jscoverage['mediator.js'][16] = 0;
  _$jscoverage['mediator.js'][17] = 0;
  _$jscoverage['mediator.js'][19] = 0;
  _$jscoverage['mediator.js'][21] = 0;
  _$jscoverage['mediator.js'][22] = 0;
  _$jscoverage['mediator.js'][24] = 0;
  _$jscoverage['mediator.js'][26] = 0;
  _$jscoverage['mediator.js'][30] = 0;
  _$jscoverage['mediator.js'][33] = 0;
  _$jscoverage['mediator.js'][39] = 0;
  _$jscoverage['mediator.js'][40] = 0;
  _$jscoverage['mediator.js'][41] = 0;
  _$jscoverage['mediator.js'][44] = 0;
  _$jscoverage['mediator.js'][52] = 0;
  _$jscoverage['mediator.js'][53] = 0;
  _$jscoverage['mediator.js'][54] = 0;
  _$jscoverage['mediator.js'][57] = 0;
  _$jscoverage['mediator.js'][58] = 0;
  _$jscoverage['mediator.js'][59] = 0;
  _$jscoverage['mediator.js'][60] = 0;
  _$jscoverage['mediator.js'][61] = 0;
  _$jscoverage['mediator.js'][64] = 0;
  _$jscoverage['mediator.js'][70] = 0;
  _$jscoverage['mediator.js'][71] = 0;
  _$jscoverage['mediator.js'][72] = 0;
  _$jscoverage['mediator.js'][73] = 0;
  _$jscoverage['mediator.js'][74] = 0;
  _$jscoverage['mediator.js'][75] = 0;
  _$jscoverage['mediator.js'][82] = 0;
  _$jscoverage['mediator.js'][83] = 0;
  _$jscoverage['mediator.js'][84] = 0;
  _$jscoverage['mediator.js'][87] = 0;
  _$jscoverage['mediator.js'][88] = 0;
  _$jscoverage['mediator.js'][89] = 0;
  _$jscoverage['mediator.js'][90] = 0;
  _$jscoverage['mediator.js'][91] = 0;
  _$jscoverage['mediator.js'][100] = 0;
  _$jscoverage['mediator.js'][102] = 0;
  _$jscoverage['mediator.js'][104] = 0;
  _$jscoverage['mediator.js'][108] = 0;
  _$jscoverage['mediator.js'][110] = 0;
  _$jscoverage['mediator.js'][111] = 0;
  _$jscoverage['mediator.js'][113] = 0;
  _$jscoverage['mediator.js'][115] = 0;
  _$jscoverage['mediator.js'][118] = 0;
  _$jscoverage['mediator.js'][120] = 0;
  _$jscoverage['mediator.js'][127] = 0;
  _$jscoverage['mediator.js'][131] = 0;
  _$jscoverage['mediator.js'][134] = 0;
  _$jscoverage['mediator.js'][135] = 0;
  _$jscoverage['mediator.js'][136] = 0;
  _$jscoverage['mediator.js'][146] = 0;
  _$jscoverage['mediator.js'][150] = 0;
  _$jscoverage['mediator.js'][151] = 0;
  _$jscoverage['mediator.js'][152] = 0;
  _$jscoverage['mediator.js'][154] = 0;
  _$jscoverage['mediator.js'][157] = 0;
  _$jscoverage['mediator.js'][158] = 0;
  _$jscoverage['mediator.js'][159] = 0;
  _$jscoverage['mediator.js'][161] = 0;
  _$jscoverage['mediator.js'][162] = 0;
  _$jscoverage['mediator.js'][166] = 0;
  _$jscoverage['mediator.js'][170] = 0;
  _$jscoverage['mediator.js'][174] = 0;
  _$jscoverage['mediator.js'][178] = 0;
  _$jscoverage['mediator.js'][180] = 0;
  _$jscoverage['mediator.js'][183] = 0;
  _$jscoverage['mediator.js'][184] = 0;
  _$jscoverage['mediator.js'][185] = 0;
  _$jscoverage['mediator.js'][189] = 0;
  _$jscoverage['mediator.js'][190] = 0;
  _$jscoverage['mediator.js'][191] = 0;
  _$jscoverage['mediator.js'][192] = 0;
  _$jscoverage['mediator.js'][201] = 0;
  _$jscoverage['mediator.js'][207] = 0;
  _$jscoverage['mediator.js'][208] = 0;
  _$jscoverage['mediator.js'][209] = 0;
  _$jscoverage['mediator.js'][210] = 0;
  _$jscoverage['mediator.js'][211] = 0;
  _$jscoverage['mediator.js'][212] = 0;
  _$jscoverage['mediator.js'][213] = 0;
  _$jscoverage['mediator.js'][216] = 0;
  _$jscoverage['mediator.js'][217] = 0;
  _$jscoverage['mediator.js'][221] = 0;
  _$jscoverage['mediator.js'][222] = 0;
  _$jscoverage['mediator.js'][224] = 0;
  _$jscoverage['mediator.js'][225] = 0;
  _$jscoverage['mediator.js'][227] = 0;
  _$jscoverage['mediator.js'][232] = 0;
  _$jscoverage['mediator.js'][233] = 0;
  _$jscoverage['mediator.js'][236] = 0;
  _$jscoverage['mediator.js'][240] = 0;
  _$jscoverage['mediator.js'][241] = 0;
  _$jscoverage['mediator.js'][242] = 0;
  _$jscoverage['mediator.js'][245] = 0;
  _$jscoverage['mediator.js'][251] = 0;
  _$jscoverage['mediator.js'][257] = 0;
  _$jscoverage['mediator.js'][262] = 0;
  _$jscoverage['mediator.js'][263] = 0;
  _$jscoverage['mediator.js'][266] = 0;
  _$jscoverage['mediator.js'][267] = 0;
  _$jscoverage['mediator.js'][269] = 0;
  _$jscoverage['mediator.js'][270] = 0;
  _$jscoverage['mediator.js'][273] = 0;
  _$jscoverage['mediator.js'][277] = 0;
  _$jscoverage['mediator.js'][287] = 0;
  _$jscoverage['mediator.js'][289] = 0;
  _$jscoverage['mediator.js'][290] = 0;
  _$jscoverage['mediator.js'][292] = 0;
  _$jscoverage['mediator.js'][302] = 0;
  _$jscoverage['mediator.js'][303] = 0;
  _$jscoverage['mediator.js'][305] = 0;
  _$jscoverage['mediator.js'][312] = 0;
  _$jscoverage['mediator.js'][319] = 0;
  _$jscoverage['mediator.js'][328] = 0;
  _$jscoverage['mediator.js'][331] = 0;
  _$jscoverage['mediator.js'][333] = 0;
  _$jscoverage['mediator.js'][338] = 0;
  _$jscoverage['mediator.js'][339] = 0;
  _$jscoverage['mediator.js'][340] = 0;
  _$jscoverage['mediator.js'][341] = 0;
  _$jscoverage['mediator.js'][342] = 0;
  _$jscoverage['mediator.js'][346] = 0;
  _$jscoverage['mediator.js'][347] = 0;
  _$jscoverage['mediator.js'][348] = 0;
}
_$jscoverage['mediator.js'].source = ["/*jslint bitwise: true, nomen: true, plusplus: true, white: true */", "", "/*!", "* Mediator.js Library v0.9.0", "* https://github.com/ajacksified/Mediator.js", "*", "* Copyright 2013, Jack Lawson", "* MIT Licensed (http://www.opensource.org/licenses/mit-license.php)", "*", "* For more information: http://thejacklawson.com/2011/06/mediators-for-modularized-asynchronous-programming-in-javascript/index.html", "* Project on GitHub: https://github.com/ajacksified/Mediator.js", "*", "* Last update: Jan 04 2013", "*/", "", "(function(root, factory) {", "  'use strict';", "", "  if(typeof root.exports === 'function') {", "    // Node/CommonJS", "    root.exports.Mediator = factory();", "  } else if(typeof root.define === 'function' &amp;&amp; root.define.amd) {", "    // AMD", "    root.define([], function() {", "      // Export to global too, for backward compatiblity", "      root.Mediator = factory();", "    });", "  } else {", "    // Browser global", "    root.Mediator = factory();", "  }", "}(this, function() {", "  'use strict';", "", "  // We'll generate guids for class instances for easy referencing later on.", "  // Subscriber instances will have an id that can be refernced for quick", "  // lookups.", "", "  function guidGenerator() {", "    var S4 = function() {", "       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);", "    };", "", "    return (S4()+S4()+\"-\"+S4()+\"-\"+S4()+\"-\"+S4()+\"-\"+S4()+S4()+S4());", "  }", "", "  // Subscribers are instances of Mediator Channel registrations. We generate", "  // an object instance so that it can be updated later on without having to", "  // unregister and re-register. Subscribers are constructed with a function", "  // to be called, options object, and context.", "", "  function Subscriber(fn, options, context){", "    if(!(this instanceof Subscriber)) {", "      return new Subscriber(fn, options, context);", "    }", "", "    this.id = guidGenerator();", "    this.fn = fn;", "    this.options = options;", "    this.context = context;", "    this.channel = null;", "  }", "", "  Subscriber.prototype = {", "    // Mediator.update on a subscriber instance can update its function,context,", "    // or options object. It takes in an object and looks for fn, context, or", "    // options keys.", "", "    update: function(options){", "      if(options){", "        this.fn = options.fn || this.fn;", "        this.context = options.context || this.context;", "        this.options = options.options || this.options;", "        if(this.channel &amp;&amp; this.options &amp;&amp; this.options.priority !== undefined) {", "            this.channel.setPriority(this.id, this.options.priority);", "        }", "      }", "    }", "  };", "", "", "  function Channel(namespace, parent){", "    if(!(this instanceof Channel)) {", "      return new Channel(namespace);", "    }", "", "    this.namespace = namespace || \"\";", "    this._subscribers = [];", "    this._channels = [];", "    this._parent = parent;", "    this.stopped = false;", "  }", "", "  // A Mediator channel holds a list of sub-channels and subscribers to be fired", "  // when Mediator.publish is called on the Mediator instance. It also contains", "  // some methods to manipulate its lists of data; only setPriority and", "  // StopPropagation are meant to be used. The other methods should be accessed", "  // through the Mediator instance.", "", "  Channel.prototype = {", "    addSubscriber: function(fn, options, context){", "      var subscriber = new Subscriber(fn, options, context);", "", "      if(options &amp;&amp; options.priority !== undefined){", "        // Cheap hack to either parse as an int or turn it into 0. Runs faster", "        // in many browsers than parseInt with the benefit that it won't", "        // return a NaN.", "        options.priority = options.priority &gt;&gt; 0;", "", "        if(options.priority &lt; 0){ options.priority = 0; }", "        if(options.priority &gt;= this._subscribers.length){ options.priority = this._subscribers.length-1; }", "", "        this._subscribers.splice(options.priority, 0, subscriber);", "      }else{", "        this._subscribers.push(subscriber);", "      }", "", "      subscriber.channel = this;", "", "      return subscriber;", "    },", "", "    // The channel instance is passed as an argument to the mediator subscriber,", "    // and further subscriber propagation can be called with", "    // channel.StopPropagation().", "    stopPropagation: function(){", "      this.stopped = true;", "    },", "", "    getSubscriber: function(identifier){", "      var x = 0,", "          y = this._subscribers.length;", "", "      for(x, y; x &lt; y; x++){", "        if(this._subscribers[x].id === identifier || this._subscribers[x].fn === identifier){", "          return this._subscribers[x];", "        }", "      }", "    },", "", "    // Channel.setPriority is useful in updating the order in which Subscribers", "    // are called, and takes an identifier (subscriber id or named function) and", "    // an array index. It will not search recursively through subchannels.", "", "    setPriority: function(identifier, priority){", "      var oldIndex = 0,", "          x = 0,", "          sub, firstHalf, lastHalf, y;", "", "      for(x = 0, y = this._subscribers.length; x &lt; y; x++){", "        if(this._subscribers[x].id === identifier || this._subscribers[x].fn === identifier){", "          break;", "        }", "        oldIndex ++;", "      }", "", "      sub = this._subscribers[oldIndex];", "      firstHalf = this._subscribers.slice(0, oldIndex);", "      lastHalf = this._subscribers.slice(oldIndex+1);", "", "      this._subscribers = firstHalf.concat(lastHalf);", "      this._subscribers.splice(priority, 0, sub);", "    },", "", "    addChannel: function(channel){", "      this._channels[channel] = new Channel((this.namespace ? this.namespace + ':' : '') + channel, this);", "    },", "", "    hasChannel: function(channel){", "      return this._channels.hasOwnProperty(channel);", "    },", "", "    returnChannel: function(channel){", "      return this._channels[channel];", "    },", "", "    removeSubscriber: function(identifier){", "      var x = 0,", "          y;", "          y = this._subscribers.length;", "", "      // If we don't pass in an id, we're clearing all", "      if(!identifier){", "        this._subscribers = [];", "        return;", "      }", "", "      // Going backwards makes splicing a whole lot easier.", "      for(x, y; y &gt; x; y--) {", "        if(this._subscribers[x].fn === identifier || this._subscribers[x].id === identifier){", "          this._subscribers[x].channel = null;", "          this._subscribers.splice(x,1);", "        }", "      }", "    },", "", "    // This will publish arbitrary arguments to a subscriber and then to parent", "    // channels.", "", "    publish: function(data){", "      var x = 0,", "          y = this._subscribers.length,", "          called = false,", "          subscriber, l;", "", "      // Priority is preserved in the _subscribers index.", "      for(x, y; x &lt; y; x++) {", "        if(!this.stopped){", "          subscriber = this._subscribers[x];", "          if(subscriber.options !== undefined &amp;&amp; typeof subscriber.options.predicate === \"function\"){", "            if(subscriber.options.predicate.apply(subscriber.context, data)){", "              subscriber.fn.apply(subscriber.context, data);", "              called = true;", "            }", "          }else{", "            subscriber.fn.apply(subscriber.context, data);", "            called = true;", "          }", "        }", "", "        if(called &amp;&amp; subscriber.options &amp;&amp; subscriber.options !== undefined){", "          subscriber.options.calls--;", "", "          if(subscriber.options.calls &lt; 1){", "            this.removeSubscriber(subscriber.id);", "          }else{", "            subscriber.update(subscriber.options);", "          }", "        }", "      }", "", "      if(this._parent){", "        this._parent.publish(data);", "      }", "", "      this.stopped = false;", "    }", "  };", "", "  function Mediator() {", "    if(!(this instanceof Mediator)) {", "      return new Mediator();", "    }", "", "    this._channels = new Channel('');", "  }", "", "  // A Mediator instance is the interface through which events are registered", "  // and removed from publish channels.", "", "  Mediator.prototype = {", "", "    // Returns a channel instance based on namespace, for example", "    // application:chat:message:received", "", "    getChannel: function(namespace){", "      var channel = this._channels,", "          namespaceHierarchy = namespace.split(':'),", "          x = 0, ", "          y = namespaceHierarchy.length;", "", "      if(namespace === ''){", "        return channel;", "      }", "", "      if(namespaceHierarchy.length &gt; 0){", "        for(x, y; x &lt; y; x++){", "", "          if(!channel.hasChannel(namespaceHierarchy[x])){", "            channel.addChannel(namespaceHierarchy[x]);", "          }", "", "          channel = channel.returnChannel(namespaceHierarchy[x]);", "        }", "      }", "", "      return channel;", "    },", "", "    // Pass in a channel namespace, function to be called, options, and context", "    // to call the function in to Subscribe. It will create a channel if one", "    // does not exist. Options can include a predicate to determine if it", "    // should be called (based on the data published to it) and a priority", "    // index.", "", "    subscribe: function(channelName, fn, options, context){", "      var channel = this.getChannel(channelName);", "", "      options = options || {};", "      context = context || {};", "", "      return channel.addSubscriber(fn, options, context);", "    },", "", "    // Pass in a channel namespace, function to be called, options, and context", "    // to call the function in to Subscribe. It will create a channel if one", "    // does not exist. Options can include a predicate to determine if it", "    // should be called (based on the data published to it) and a priority", "    // index.", "", "    once: function(channelName, fn, options, context){", "      options = options || {};", "      options.calls = 1;", "", "      return this.subscribe(channelName, fn, options, context);", "    },", "", "    // Returns a subscriber for a given subscriber id / named function and", "    // channel namespace", "", "    getSubscriber: function(identifier, channel){", "      return this.getChannel(channel || \"\").getSubscriber(identifier);", "    },", "", "    // Remove a subscriber from a given channel namespace recursively based on", "    // a passed-in subscriber id or named function.", "", "    remove: function(channelName, identifier){", "      this.getChannel(channelName).removeSubscriber(identifier);", "    },", "", "    // Publishes arbitrary data to a given channel namespace. Channels are", "    // called recursively downwards; a post to application:chat will post to", "    // application:chat:receive and application:chat:derp:test:beta:bananas.", "    // Called using Mediator.publish(\"application:chat\", [ args ]);", "", "    publish: function(channelName){", "      var args = Array.prototype.slice.call(arguments, 1),", "          channel = this.getChannel(channelName);", "", "      args.push(channel);", "", "      this.getChannel(channelName).publish(args);", "    }", "  };", "", "  // Alias some common names for easy interop", "  Mediator.prototype.on = Mediator.prototype.subscribe;", "  Mediator.prototype.bind = Mediator.prototype.subscribe;", "  Mediator.prototype.emit = Mediator.prototype.publish;", "  Mediator.prototype.trigger = Mediator.prototype.publish;", "  Mediator.prototype.off = Mediator.prototype.remove;", "", "  // Finally, expose it all.", "", "  Mediator.Channel = Channel;", "  Mediator.Subscriber = Subscriber;", "  return Mediator;", "}));"];
_$jscoverage['mediator.js'][16]++;
(function (root, factory) {
  _$jscoverage['mediator.js'][17]++;
  "use strict";
  _$jscoverage['mediator.js'][19]++;
  if (typeof root.exports === "function") {
    _$jscoverage['mediator.js'][21]++;
    root.exports.Mediator = factory();
  } else {
    _$jscoverage['mediator.js'][22]++;
    if (typeof root.define === "function" && root.define.amd) {
      _$jscoverage['mediator.js'][24]++;
      root.define([], function () {
        _$jscoverage['mediator.js'][26]++;
        root.Mediator = factory();
      });
    } else {
      _$jscoverage['mediator.js'][30]++;
      root.Mediator = factory();
    }
  }
})(this, function () {
  _$jscoverage['mediator.js'][33]++;
  "use strict";
  _$jscoverage['mediator.js'][39]++;
  function guidGenerator() {
    _$jscoverage['mediator.js'][40]++;
    var S4 = function () {
      _$jscoverage['mediator.js'][41]++;
      return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
    };
    _$jscoverage['mediator.js'][44]++;
    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
  }
  _$jscoverage['mediator.js'][52]++;
  function Subscriber(fn, options, context) {
    _$jscoverage['mediator.js'][53]++;
    if (!(this instanceof Subscriber)) {
      _$jscoverage['mediator.js'][54]++;
      return new Subscriber(fn, options, context);
    }
    _$jscoverage['mediator.js'][57]++;
    this.id = guidGenerator();
    _$jscoverage['mediator.js'][58]++;
    this.fn = fn;
    _$jscoverage['mediator.js'][59]++;
    this.options = options;
    _$jscoverage['mediator.js'][60]++;
    this.context = context;
    _$jscoverage['mediator.js'][61]++;
    this.channel = null;
  }
  _$jscoverage['mediator.js'][64]++;
  Subscriber.prototype = {
    update: function (options) {
      _$jscoverage['mediator.js'][70]++;
      if (options) {
        _$jscoverage['mediator.js'][71]++;
        this.fn = options.fn || this.fn;
        _$jscoverage['mediator.js'][72]++;
        this.context = options.context || this.context;
        _$jscoverage['mediator.js'][73]++;
        this.options = options.options || this.options;
        _$jscoverage['mediator.js'][74]++;
        if (this.channel && this.options && this.options.priority !== undefined) {
          _$jscoverage['mediator.js'][75]++;
          this.channel.setPriority(this.id, this.options.priority);
        }
      }
    }
  };
  _$jscoverage['mediator.js'][82]++;
  function Channel(namespace, parent) {
    _$jscoverage['mediator.js'][83]++;
    if (!(this instanceof Channel)) {
      _$jscoverage['mediator.js'][84]++;
      return new Channel(namespace);
    }
    _$jscoverage['mediator.js'][87]++;
    this.namespace = namespace || "";
    _$jscoverage['mediator.js'][88]++;
    this._subscribers = [];
    _$jscoverage['mediator.js'][89]++;
    this._channels = [];
    _$jscoverage['mediator.js'][90]++;
    this._parent = parent;
    _$jscoverage['mediator.js'][91]++;
    this.stopped = false;
  }
  _$jscoverage['mediator.js'][100]++;
  Channel.prototype = {
    addSubscriber: function (fn, options, context) {
      _$jscoverage['mediator.js'][102]++;
      var subscriber = new Subscriber(fn, options, context);
      _$jscoverage['mediator.js'][104]++;
      if (options && options.priority !== undefined) {
        _$jscoverage['mediator.js'][108]++;
        options.priority = options.priority >> 0;
        _$jscoverage['mediator.js'][110]++;
        if (options.priority < 0) {
          _$jscoverage['mediator.js'][110]++;
          options.priority = 0;
        }
        _$jscoverage['mediator.js'][111]++;
        if (options.priority >= this._subscribers.length) {
          _$jscoverage['mediator.js'][111]++;
          options.priority = this._subscribers.length - 1;
        }
        _$jscoverage['mediator.js'][113]++;
        this._subscribers.splice(options.priority, 0, subscriber);
      } else {
        _$jscoverage['mediator.js'][115]++;
        this._subscribers.push(subscriber);
      }
      _$jscoverage['mediator.js'][118]++;
      subscriber.channel = this;
      _$jscoverage['mediator.js'][120]++;
      return subscriber;
    },
    stopPropagation: function () {
      _$jscoverage['mediator.js'][127]++;
      this.stopped = true;
    },
    getSubscriber: function (identifier) {
      _$jscoverage['mediator.js'][131]++;
      var x = 0,
        y = this._subscribers.length;
      _$jscoverage['mediator.js'][134]++;
      for (x, y; x < y; x++) {
        _$jscoverage['mediator.js'][135]++;
        if (this._subscribers[x].id === identifier || this._subscribers[x].fn === identifier) {
          _$jscoverage['mediator.js'][136]++;
          return this._subscribers[x];
        }
      }
    },
    setPriority: function (identifier, priority) {
      _$jscoverage['mediator.js'][146]++;
      var oldIndex = 0,
        x = 0,
        sub,
        firstHalf,
        lastHalf,
        y;
      _$jscoverage['mediator.js'][150]++;
      for (x = 0, y = this._subscribers.length; x < y; x++) {
        _$jscoverage['mediator.js'][151]++;
        if (this._subscribers[x].id === identifier || this._subscribers[x].fn === identifier) {
          _$jscoverage['mediator.js'][152]++;
          break;
        }
        _$jscoverage['mediator.js'][154]++;
        oldIndex++;
      }
      _$jscoverage['mediator.js'][157]++;
      sub = this._subscribers[oldIndex];
      _$jscoverage['mediator.js'][158]++;
      firstHalf = this._subscribers.slice(0, oldIndex);
      _$jscoverage['mediator.js'][159]++;
      lastHalf = this._subscribers.slice(oldIndex + 1);
      _$jscoverage['mediator.js'][161]++;
      this._subscribers = firstHalf.concat(lastHalf);
      _$jscoverage['mediator.js'][162]++;
      this._subscribers.splice(priority, 0, sub);
    },
    addChannel: function (channel) {
      _$jscoverage['mediator.js'][166]++;
      this._channels[channel] = new Channel((this.namespace ? this.namespace + ":" : "") + channel, this);
    },
    hasChannel: function (channel) {
      _$jscoverage['mediator.js'][170]++;
      return this._channels.hasOwnProperty(channel);
    },
    returnChannel: function (channel) {
      _$jscoverage['mediator.js'][174]++;
      return this._channels[channel];
    },
    removeSubscriber: function (identifier) {
      _$jscoverage['mediator.js'][178]++;
      var x = 0,
        y;
      _$jscoverage['mediator.js'][180]++;
      y = this._subscribers.length;
      _$jscoverage['mediator.js'][183]++;
      if (!identifier) {
        _$jscoverage['mediator.js'][184]++;
        this._subscribers = [];
        _$jscoverage['mediator.js'][185]++;
        return;
      }
      _$jscoverage['mediator.js'][189]++;
      for (x, y; y > x; y--) {
        _$jscoverage['mediator.js'][190]++;
        if (this._subscribers[x].fn === identifier || this._subscribers[x].id === identifier) {
          _$jscoverage['mediator.js'][191]++;
          this._subscribers[x].channel = null;
          _$jscoverage['mediator.js'][192]++;
          this._subscribers.splice(x, 1);
        }
      }
    },
    publish: function (data) {
      _$jscoverage['mediator.js'][201]++;
      var x = 0,
        y = this._subscribers.length,
        called = false,
        subscriber,
        l;
      _$jscoverage['mediator.js'][207]++;
      for (x, y; x < y; x++) {
        _$jscoverage['mediator.js'][208]++;
        if (!this.stopped) {
          _$jscoverage['mediator.js'][209]++;
          subscriber = this._subscribers[x];
          _$jscoverage['mediator.js'][210]++;
          if (subscriber.options !== undefined && typeof subscriber.options.predicate === "function") {
            _$jscoverage['mediator.js'][211]++;
            if (subscriber.options.predicate.apply(subscriber.context, data)) {
              _$jscoverage['mediator.js'][212]++;
              subscriber.fn.apply(subscriber.context, data);
              _$jscoverage['mediator.js'][213]++;
              called = true;
            }
          } else {
            _$jscoverage['mediator.js'][216]++;
            subscriber.fn.apply(subscriber.context, data);
            _$jscoverage['mediator.js'][217]++;
            called = true;
          }
        }
        _$jscoverage['mediator.js'][221]++;
        if (called && subscriber.options && subscriber.options !== undefined) {
          _$jscoverage['mediator.js'][222]++;
          subscriber.options.calls--;
          _$jscoverage['mediator.js'][224]++;
          if (subscriber.options.calls < 1) {
            _$jscoverage['mediator.js'][225]++;
            this.removeSubscriber(subscriber.id);
          } else {
            _$jscoverage['mediator.js'][227]++;
            subscriber.update(subscriber.options);
          }
        }
      }
      _$jscoverage['mediator.js'][232]++;
      if (this._parent) {
        _$jscoverage['mediator.js'][233]++;
        this._parent.publish(data);
      }
      _$jscoverage['mediator.js'][236]++;
      this.stopped = false;
    }
  };
  _$jscoverage['mediator.js'][240]++;
  function Mediator() {
    _$jscoverage['mediator.js'][241]++;
    if (!(this instanceof Mediator)) {
      _$jscoverage['mediator.js'][242]++;
      return new Mediator();
    }
    _$jscoverage['mediator.js'][245]++;
    this._channels = new Channel("");
  }
  _$jscoverage['mediator.js'][251]++;
  Mediator.prototype = {
    getChannel: function (namespace) {
      _$jscoverage['mediator.js'][257]++;
      var channel = this._channels,
        namespaceHierarchy = namespace.split(":"),
        x = 0,
        y = namespaceHierarchy.length;
      _$jscoverage['mediator.js'][262]++;
      if (namespace === "") {
        _$jscoverage['mediator.js'][263]++;
        return channel;
      }
      _$jscoverage['mediator.js'][266]++;
      if (namespaceHierarchy.length > 0) {
        _$jscoverage['mediator.js'][267]++;
        for (x, y; x < y; x++) {
          _$jscoverage['mediator.js'][269]++;
          if (!channel.hasChannel(namespaceHierarchy[x])) {
            _$jscoverage['mediator.js'][270]++;
            channel.addChannel(namespaceHierarchy[x]);
          }
          _$jscoverage['mediator.js'][273]++;
          channel = channel.returnChannel(namespaceHierarchy[x]);
        }
      }
      _$jscoverage['mediator.js'][277]++;
      return channel;
    },
    subscribe: function (channelName, fn, options, context) {
      _$jscoverage['mediator.js'][287]++;
      var channel = this.getChannel(channelName);
      _$jscoverage['mediator.js'][289]++;
      options = options || {};
      _$jscoverage['mediator.js'][290]++;
      context = context || {};
      _$jscoverage['mediator.js'][292]++;
      return channel.addSubscriber(fn, options, context);
    },
    once: function (channelName, fn, options, context) {
      _$jscoverage['mediator.js'][302]++;
      options = options || {};
      _$jscoverage['mediator.js'][303]++;
      options.calls = 1;
      _$jscoverage['mediator.js'][305]++;
      return this.subscribe(channelName, fn, options, context);
    },
    getSubscriber: function (identifier, channel) {
      _$jscoverage['mediator.js'][312]++;
      return this.getChannel(channel || "").getSubscriber(identifier);
    },
    remove: function (channelName, identifier) {
      _$jscoverage['mediator.js'][319]++;
      this.getChannel(channelName).removeSubscriber(identifier);
    },
    publish: function (channelName) {
      _$jscoverage['mediator.js'][328]++;
      var args = Array.prototype.slice.call(arguments, 1),
        channel = this.getChannel(channelName);
      _$jscoverage['mediator.js'][331]++;
      args.push(channel);
      _$jscoverage['mediator.js'][333]++;
      this.getChannel(channelName).publish(args);
    }
  };
  _$jscoverage['mediator.js'][338]++;
  Mediator.prototype.on = Mediator.prototype.subscribe;
  _$jscoverage['mediator.js'][339]++;
  Mediator.prototype.bind = Mediator.prototype.subscribe;
  _$jscoverage['mediator.js'][340]++;
  Mediator.prototype.emit = Mediator.prototype.publish;
  _$jscoverage['mediator.js'][341]++;
  Mediator.prototype.trigger = Mediator.prototype.publish;
  _$jscoverage['mediator.js'][342]++;
  Mediator.prototype.off = Mediator.prototype.remove;
  _$jscoverage['mediator.js'][346]++;
  Mediator.Channel = Channel;
  _$jscoverage['mediator.js'][347]++;
  Mediator.Subscriber = Subscriber;
  _$jscoverage['mediator.js'][348]++;
  return Mediator;
});